export const formatLocalDateTime = (
  value,
  {
    locale = "en-IN",
    hour12 = true,
    includeSeconds = false,
    fallback = "-",
  } = {}
) => {
  if (!value) return fallback;

  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);

  return date.toLocaleString(locale, {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    ...(includeSeconds ? { second: "2-digit" } : {}),
    hour12,
  });
};

